var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('AModal',{attrs:{"footer":null,"visible":_vm.isVisible,"width":_vm.modalWidth.MEDIUM_WIDE},on:{"cancel":_vm.onCancel}},[_c('WorkflowContainer',{key:_vm.componentKey,attrs:{"active-label-id":_vm.labelId,"is-order-status-active":_vm.projectHasOrderStatus,"is-readonly":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }